import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal, Icon } from 'antd';
import './LegalDoc.css';

const LinkLegalDoc = ({ isBurger }) => {
  const [visible, setVisible] = useState(false);
  const modalShow = () => {
    setVisible(true);
  };
  const modalHide = () => {
    setVisible(false);
  };
  return (
    <Fragment>
      {isBurger ? (
        <Link style={{ color: '#ffffff' }} to={'#'} onClick={modalShow}>
          Правовые документы сервиса
        </Link>
      ) : (
        <Link to={'#'} onClick={modalShow}>
          Правовые документы сервиса
        </Link>
      )}
      <Modal
        destroyOnClose={true}
        visible={visible}
        width={542}
        title={
          <div className="legalDoc__head">
            <div className="legalDoc__head-icon">
              <Icon type="file-text" />
            </div>
            <div className="legalDoc__head-title">
              Правовые документы сервиса
            </div>
          </div>
        }
        className="legalDoc"
        footer={[
          <Button key="ok" type="primary" onClick={modalHide}>
            Закрыть
          </Button>,
        ]}
        closable={true}
        onCancel={modalHide}
      >
        <div className="legalDoc__content">
          <div className="legalDoc__file">
            <a href="/files/doc/legal/chartering_contract.pdf" target="_blank">
              Договор фрахтования
            </a>
          </div>
          <div className="legalDoc__file">
            <a href="/files/doc/legal/license_agreement.pdf" target="_blank">
              Лицензионное соглашение на использование базы данных «TELEPORTOS»
              и прикладной программы «TELEPORTOS»
            </a>
          </div>
          <div className="legalDoc__file">
            <a
              href="/files/doc/legal/agreement_to_process_personal_data.pdf"
              target="_blank"
              rel="opener"
            >
              Согласие на обработку персональных данных
            </a>
          </div>
          <div className="legalDoc__file">
            <a href="/files/doc/legal/security_policy.pdf" target="_blank">
              Политика ООО «СИРЕНА БАС» в отношении обработки персональных
              данных и защиты персональных данных
            </a>
          </div>
          <div className="legalDoc__file">
            <a href="/files/doc/legal/service_rules.pdf" target="_blank">
              Договор об оказании тендерных услуг. правила сервиса «TELEPORTOS».
            </a>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

export default LinkLegalDoc;
